module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentTab) ? _c('div', {
    staticClass: "full logs"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-item"
    }, [_c('button', {
      staticClass: "nav-link",
      class: tab.id === _vm.currentTab.id ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(tab.name) + "\n                ")])])
  })), _vm._v(" "), _c('section', {
    key: _vm.currentTab.id,
    staticClass: "content_logs"
  }, [_c('div', {
    staticClass: "table-responsive mt-4"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.files), function(file) {
    return _c('tr', {
      key: file.id
    }, [_c('td', {
      staticClass: "px-3"
    }, [_vm._v(_vm._s(_vm.getDateByFormat(file.date, "DD/MM/YYYY - HH:mm")))]), _vm._v(" "), _c('td', {
      staticClass: "px-3"
    }, [_vm._v(_vm._s(file.formatFileName))]), _vm._v(" "), _c('td', {
      staticClass: "px-3"
    }, [_c('ClientColorButton', {
      attrs: {
        "inactive-color": true
      },
      on: {
        "click": function($event) {
          _vm.downloadFile(file)
        }
      }
    }, [_vm._v("Download")])], 1)])
  }))])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h1', {
    staticClass: "header-title"
  }, [_vm._v("Archives")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("File")]), _vm._v(" "), _c('th', [_vm._v("Download")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04c876dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/export/ExportExcel.vue
// module id = 2987
// module chunks = 0